<template>
    <div class="container">
        <div class="option">
            <div class="circle noise"></div>
            <div class="name">{{$l('calendar/noise')}}</div>
        </div>
        <div class="option">
            <div class="circle audio"></div>
            <div class="name">{{$l('calendar/audio')}}</div>
        </div>
        <div class="option">
            <div class="circle weather"></div>
            <div class="name">{{$l('calendar/weather')}}</div>
        </div>
        <div class="option">
            <div class="circle video"></div>
            <div class="name">{{$l('calendar/video')}}</div>
        </div>
        <div class="option">
            <div class="circle adio"></div>
            <div class="name">{{$l('calendar/adio')}}</div>
        </div>
    </div>
</template>

<style scoped>
    .container{
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        
    }
    .circle{
        margin: 1px;
        margin-top:4px;
        margin-right:5px;
        height:5px;
        width: 5px;
        border-radius: 50%;
        float:left;
    }
    .name{

    }
    .audio{background-color: #E7505A;}
    .noise{background-color: #4C87B9;}
    .weather{background-color:#13CE66;}
    .video{background-color:#F7BA2A;}
    .adio{background-color: #daff00;}
</style>

<script>
export default {

}
</script>




// WEBPACK FOOTER //
// CalendarLegendPopover.vue?6485a344